import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [categoryOpen, setCategoryOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { label: '首页', href: '/' },
    { label: '分类', href: '/category', hasDropdown: true },
    { label: '关于我们', href: '/about' },
  ];

  const categories = [
    { label: '悬疑推理', href: '/category?cat=悬疑' },
    { label: '恐怖惊悚', href: '/category?cat=恐怖' },
    { label: '奇幻修仙', href: '/category?cat=奇幻' },
    { label: '冒险探索', href: '/category?cat=冒险' },
    { label: '科幻机甲', href: '/category?cat=科幻' },
    { label: '热血战斗', href: '/category?cat=热血' },
  ];

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-background-50/80 backdrop-blur-md border-b border-background-300/30">
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-3">
            <div className="w-9 h-9 rounded-full bg-primary-500 flex items-center justify-center">
              <i className="ri-book-open-line text-background-50 text-lg"></i>
            </div>
            <span className="text-foreground-100 font-heading text-xl font-bold whitespace-nowrap">叮当漫画网</span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm transition-colors whitespace-nowrap ${location.pathname === '/' ? 'text-primary-500' : 'text-foreground-400 hover:text-foreground-100'}`}
            >
              首页
            </Link>
            <div className="relative" onMouseEnter={() => setCategoryOpen(true)} onMouseLeave={() => setCategoryOpen(false)}>
              <Link
                to="/category"
                className={`text-sm transition-colors whitespace-nowrap flex items-center gap-1 ${location.pathname === '/category' ? 'text-primary-500' : 'text-foreground-400 hover:text-foreground-100'}`}
              >
                分类
                <i className="ri-arrow-down-s-line text-xs"></i>
              </Link>
              {categoryOpen && (
                <div className="absolute top-full left-0 mt-2 w-40 bg-background-100 border border-background-300/40 rounded-lg py-2">
                  {categories.map((cat) => (
                    <Link
                      key={cat.label}
                      to={cat.href}
                      className="block px-4 py-2 text-sm text-foreground-400 hover:text-foreground-100 hover:bg-background-200/50 transition-colors"
                    >
                      {cat.label}
                    </Link>
                  ))}
                </div>
              )}
            </div>
            <Link
              to="/about"
              className={`text-sm transition-colors whitespace-nowrap ${location.pathname === '/about' ? 'text-primary-500' : 'text-foreground-400 hover:text-foreground-100'}`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-4">
            <button className="w-9 h-9 flex items-center justify-center text-foreground-400 hover:text-foreground-100 transition-colors cursor-pointer" aria-label="搜索">
              <i className="ri-search-line text-lg"></i>
            </button>
            <Link
              to="/article/1"
              className="px-5 py-2 bg-primary-500 hover:bg-primary-600 text-background-50 dark:text-foreground-950 text-sm font-medium rounded-full transition-colors whitespace-nowrap cursor-pointer flex items-center gap-2"
            >
              开始阅读
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <button
            className="md:hidden w-9 h-9 flex items-center justify-center text-foreground-100 cursor-pointer"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-300/30 px-4 py-4">
          <Link
            to="/"
            onClick={() => setMobileMenuOpen(false)}
            className="block py-3 text-foreground-400 hover:text-foreground-100 text-sm"
          >
            首页
          </Link>
          <Link
            to="/category"
            onClick={() => setMobileMenuOpen(false)}
            className="block py-3 text-foreground-400 hover:text-foreground-100 text-sm"
          >
            分类
          </Link>
          {categories.map((cat) => (
            <Link
              key={cat.label}
              to={cat.href}
              onClick={() => setMobileMenuOpen(false)}
              className="block py-2 pl-4 text-foreground-500 hover:text-foreground-200 text-xs"
            >
              {cat.label}
            </Link>
          ))}
          <Link
            to="/about"
            onClick={() => setMobileMenuOpen(false)}
            className="block py-3 text-foreground-400 hover:text-foreground-100 text-sm"
          >
            关于我们
          </Link>
          <Link
            to="/article/1"
            onClick={() => setMobileMenuOpen(false)}
            className="mt-3 inline-block px-5 py-2 bg-primary-500 text-background-50 dark:text-foreground-950 text-sm font-medium rounded-full whitespace-nowrap"
          >
            开始阅读
          </Link>
        </div>
      )}
    </nav>
  );
}